import React, { Component } from "react";
import ReactPlayer from "react-player";

class App extends Component {
  state = {
    videoUrl: "",
    playing: true,
    controls: true,
    volume: 0.2,
    muted: false,
    playbackRate: 1.0,
    outputName: "output.mp4",
    startTime: 0,
    endTime: 0,
    generatedVideoUrl: '',
    generating: false,
  };

  load = (url) => {
    this.setState({
      url,
      played: 0,
    });
  };

  handlePlayPause = () => {
    this.setState({ playing: !this.state.playing });
  };

  handleToggleControls = () => {
    const url = this.state.url;
    this.setState(
      {
        controls: !this.state.controls,
        url: null,
      },
      () => this.load(url)
    );
  };

  handleVolumeChange = (e) => {
    this.setState({ volume: parseFloat(e.target.value) });
  };

  handleToggleMuted = () => {
    this.setState({ muted: !this.state.muted });
  };

  handleSetPlaybackRate = (e) => {
    this.setState({ playbackRate: parseFloat(e.target.value) });
  };

  handleOnPlaybackRateChange = (speed) => {
    this.setState({ playbackRate: parseFloat(speed) });
  };

  handlePlay = () => {
    console.log("onPlay");
    this.setState({ playing: true });
  };

  handlePause = () => {
    console.log("onPause");
    this.setState({ playing: false });
  };

  handleSeekMouseDown = (e) => {
    this.setState({ seeking: true });
  };

  handleSeekChange = (e) => {
    this.setState({ played: parseFloat(e.target.value) });
  };

  handleSeekMouseUp = (e) => {
    this.setState({ seeking: false });
    this.player.seekTo(parseFloat(e.target.value));
  };

  handleProgress = (state) => {
    console.log("onProgress", state);
    // We only want to update time slider if we are not currently seeking
    if (!this.state.seeking) {
      this.setState(state);
    }
  };

  handleGenerateClip = () => {
    const { outputName, startTime, endTime, videoUrl } = this.state;
    this.setState({ generating: true, generatedVideoUrl: '' }); // Start generating

    fetch("/generate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ outputName, startTime, endTime, videoUrl }),
    })
    .then(response => response.json())
    .then(data => {
      this.setState({
        generating: false,
        generatedVideoUrl: data.url,
      });
    })
    .catch(error => {
      console.error("Error:", error);
      this.setState({
        generating: false,
        generatedVideoUrl: "Error processing video",
      });
    });
  };

  handleSetCurrentTimeAsStart = () => {
    const currentTime = this.player.getCurrentTime();
    this.setState({ startTime: currentTime });
  };

  handleSetCurrentTimeAsEnd = () => {
    const currentTime = this.player.getCurrentTime();
    this.setState({ endTime: currentTime });
  };

  formatTime = (seconds) => {
    const pad = (num, size) => ('000' + num).slice(size * -1);
    const time = parseFloat(seconds).toFixed(3);
    const hours = Math.floor(time / 60 / 60);
    const minutes = Math.floor(time / 60) % 60;
    const secs = Math.floor(time - minutes * 60 - hours * 3600);
    const millis = parseInt((time - Math.floor(time)) * 1000, 10);

    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(secs, 2) + '.' + pad(millis, 3);
  }

  ref = (player) => {
    this.player = player;
  };

  render() {
    const {
      videoUrl,
      playing,
      controls,
      volume,
      muted,
      played,
      playbackRate,
      outputName,
      startTime,
      endTime,
      generatedVideoUrl,
      generating,
    } = this.state;
    const formattedStartTime = this.formatTime(startTime);
    const formattedEndTime = this.formatTime(endTime);
    const SEPARATOR = " · ";

    return (
      <div className="app">
        <section className="section">
          <h1>Video Clip Maker</h1>
          <div className="player-wrapper">
            <ReactPlayer
              ref={this.ref}
              className="react-player"
              width="100%"
              height="100%"
              url={videoUrl}
              playing={playing}
              controls={controls}
              playbackRate={playbackRate}
              volume={volume}
              muted={muted}
              onReady={() => console.log("onReady")}
              onStart={() => console.log("onStart")}
              onPlay={this.handlePlay}
              onPause={this.handlePause}
              onBuffer={() => console.log("onBuffer")}
              onPlaybackRateChange={this.handleOnPlaybackRateChange}
              onSeek={(e) => console.log("onSeek", e)}
              onError={(e) => console.log("onError", e)}
              onProgress={this.handleProgress}
              onPlaybackQualityChange={(e) =>
                console.log("onPlaybackQualityChange", e)
              }
            />
          </div>

          <section className="section">
            <div>
              Output Name:
              <input
                type="text"
                placeholder="Output Name"
                value={outputName}
                onChange={(e) => this.setState({ outputName: e.target.value })}
              />
            </div>
            <div>Start Time: {formattedStartTime}</div>
            <div>End Time: {formattedEndTime}</div>
            <button onClick={this.handleSetCurrentTimeAsStart}>
              Set Start Time
            </button>
            <button onClick={this.handleSetCurrentTimeAsEnd}>
              Set End Time
            </button>
            <button onClick={this.handleGenerateClip}>Generate Clip</button>
          </section>

          <table>
            <tbody>
              <tr>
                <th>Controls</th>
                <td>
                  <button onClick={this.handlePlayPause}>
                    {playing ? "Pause" : "Play"}
                  </button>
                </td>
              </tr>
              <tr>
                <th>Speed</th>
                <td>
                  <button onClick={this.handleSetPlaybackRate} value={1}>
                    1x
                  </button>
                  <button onClick={this.handleSetPlaybackRate} value={1.5}>
                    1.5x
                  </button>
                  <button onClick={this.handleSetPlaybackRate} value={2}>
                    2x
                  </button>
                  Current Speed: {playbackRate}
                </td>
              </tr>
              <tr>
                <th>Seek</th>
                <td>
                  <input
                    type="range"
                    min={0}
                    max={0.999999}
                    step="any"
                    value={played}
                    onMouseDown={this.handleSeekMouseDown}
                    onChange={this.handleSeekChange}
                    onMouseUp={this.handleSeekMouseUp}
                  />
                </td>
              </tr>
              <tr>
                <th>Volume</th>
                <td>
                  <input
                    type="range"
                    min={0}
                    max={1}
                    step="any"
                    value={volume}
                    onChange={this.handleVolumeChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label htmlFor="controls">Controls</label>
                </th>
                <td>
                  <input
                    id="controls"
                    type="checkbox"
                    checked={controls}
                    onChange={this.handleToggleControls}
                  />
                  <em>&nbsp; Requires player reload</em>
                </td>
              </tr>
              <tr>
                <th>
                  <label htmlFor="muted">Muted</label>
                </th>
                <td>
                  <input
                    id="muted"
                    type="checkbox"
                    checked={muted}
                    onChange={this.handleToggleMuted}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section className="section">
          <table>
            <tbody>
              <tr>
                <th>URL</th>
                <td>
                  <input
                    ref={(input) => {
                      this.urlInput = input;
                    }}
                    type="text"
                    placeholder="Enter URL"
                  />
                  <button
                    onClick={() => this.setState({ videoUrl: this.urlInput.value })}
                  >
                    Load
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <table>
            <tbody>
              <tr>
                <td className={!videoUrl ? "faded" : ""}>
                  {(videoUrl instanceof Array ? "Multiple" : videoUrl) || "null"}
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        {generating && <p>Generating . . .</p>}
        {generatedVideoUrl && !generating && generatedVideoUrl.startsWith('Error') ? (
          <p>{generatedVideoUrl}</p>
        ) : (
          <a href={generatedVideoUrl} target="_blank" rel="noopener noreferrer" style={{ display: generatedVideoUrl ? "block" : "none" }}>
            Download Video
          </a>
        )}
      </div>
    );
  }
}

export default App;
